var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrinterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.833 8.333h-1.666V6.667h-8.334v1.666H9.166v-2.5A.833.833 0 0110 5h10a.833.833 0 01.833.833v2.5zM20.833 9.167H9.167A4.172 4.172 0 005 13.333V20a.833.833 0 00.833.833h3.334v3.334A.833.833 0 0010 25h10a.833.833 0 00.833-.833v-3.334h3.334A.833.833 0 0025 20v-6.667a4.172 4.172 0 00-4.167-4.166zm-1.666 14.166h-8.334V17.5h8.334v5.833zM20 14.167a.833.833 0 110-1.667.833.833 0 010 1.667z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterIcon);
export default __webpack_public_path__ + "static/media/printerIcon.365994ad.svg";
export { ForwardRef as ReactComponent };